import { render } from "./Generateqr.vue?vue&type=template&id=c64a2138"
import script from "./Generateqr.vue?vue&type=script&lang=js"
export * from "./Generateqr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__